import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    paramName: String,
    paramValue: String,
  };

  submit(e) {
    // Without preventing default for `e`, turbo was unable to preserve scroll
    e.preventDefault();

    const form = this.element.form || this.element.closest('form');

    // Disable all submit buttons on the page to avoid multiple submissions
    const allSubmitButtons = form.querySelectorAll('input[type="submit"], button[type="submit"], button:not([type])');
    allSubmitButtons.forEach(button => {
      button.disabled = true;
    });

    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = this.paramNameValue;
    hiddenInput.value = this.paramValueValue;
    form.appendChild(hiddenInput);

    // we don't want to client side validation when using this controller
    form.setAttribute('novalidate', 'true');

    form.requestSubmit(this.element.type === 'submit' ? this.element : null);
  }
}
